/**
 * Sync TipTap / draft HTML to the same plain-text block segmentation the backend
 * uses for EditableDoc (double newline between blocks; matches plan_doc_edits).
 */

export function escapeHtmlForDraft(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

export function draftHtmlToWorkingPlainText(html: string): string {
  const trimmed = html.trim();
  if (!trimmed) return '';

  if (typeof DOMParser !== 'undefined') {
    const doc = new DOMParser().parseFromString(trimmed, 'text/html');
    const blocks: string[] = [];
    doc.querySelectorAll('p, h1, h2, h3, h4, h5, h6, li, blockquote').forEach((el) => {
      const t = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (t) blocks.push(t);
    });
    if (blocks.length > 0) return blocks.join('\n\n');
    const t = (doc.body?.textContent || '').replace(/\s+/g, ' ').trim();
    if (t) return t;
  }

  return trimmed
    .replace(/<\/p>/gi, '\n\n')
    .replace(/<\/h[1-6]>/gi, '\n\n')
    .replace(/<\/li>/gi, '\n')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<[^>]+>/g, '')
    .trim();
}

export function paragraphsToSimpleDraftHtml(paragraphs: string[]): string {
  return paragraphs.map((p) => `<p>${escapeHtmlForDraft(p)}</p>`).join('');
}
